import React from "react";
import { useState } from "react";
import { GlobalContext } from "../components/context";
import PropTypes from "prop-types";

const GlobalState = (props) => {
  const { children } = props;

  const [userName, setUserName] = useState("");
  const [userBirthDate, setUserBirthDate] = useState(new Date());

  return (
    <GlobalContext.Provider
      value={{
        userName,
        setUserName,
        userBirthDate,
        setUserBirthDate,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

GlobalState.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GlobalState;
